interface CompulsoryKpi {
    id: number;
    description: string;
    enabled: boolean;
}

const EmptyCompulsoryKpi: CompulsoryKpi = {
    id: 0,
    description: '',
    enabled: true
};

export { EmptyCompulsoryKpi };

export default CompulsoryKpi;
